import React from 'react';
import { Link } from 'react-router-dom';
import { CompanyLogo } from '@/Components/shared';
import RoutePath from '@/Routing/RoutePath';
import { useCompanyIdRoute } from '@/Routing/useCompanyIdRoute';
import UIStrings from '@/Utils/UIStrings';
import ProfileMenuButton from './TopBarMenu/ProfileMenuButton';
import { cn } from '@/lib/utils';
import { Button } from '../shadcn';

interface TopBarProps {
    onlyLogo?: boolean;
    className?: string;
}

const TopBar = ({ className, onlyLogo }: TopBarProps) => {
    const rootPath = useCompanyIdRoute(RoutePath.CompanyRoot);

    return (
        <header className={cn('border-border bg-background h-22 max-h-22 min-h-22 border-b', className)}>
            <div className="bg-card flex h-full w-full items-stretch px-16">
                <div className="bg-background flex w-auto shrink-0 items-center justify-center gap-12">
                    <Link to={rootPath} className="flex h-10 w-48 shrink-0 items-center justify-center">
                        <CompanyLogo color="primary" height={40} width={200} aria-label={UIStrings.CompanyLogo} />
                    </Link>
                    {!onlyLogo && (
                        <Button data-cy="myCompaniesButton" asChild variant="ghost" size="sm">
                            <Link to={rootPath} className="flex">
                                {UIStrings.MyCompanies}
                            </Link>
                        </Button>
                    )}
                </div>
                {!onlyLogo && (
                    <>
                        <div className="min-w-0 flex-1" />
                        <div className="flex shrink-0 flex-wrap items-center" data-cy="TopBarMenuSection">
                            <ProfileMenuButton />
                        </div>
                    </>
                )}
            </div>
        </header>
    );
};

export default TopBar;
